import {
  aipBenefits,
  bssBenefits,
  cashFlowProtectionBenefits,
  criticareBenefits,
  foreverPensionBenefits,
  fspFlexiIncomeAndProBenefits,
  fspLargeSumBenefits,
  gcapBenefits,
  gssLumpsumIncomeBenefits,
  incomeBuilderBenefits,
  pgsBenefits,
  posForeverPensionBenefits,
  posGSSBenefits,
  posSaralNiveshBenefits,
  singlePayEndowmentBenefits,
  wealthPremierBenefits,
  wealthUltimaBenefits,
  zindagiProtectLCOBenefits,
  activePensionPlusBenefits
} from "constants/ProductBenefitsList";
import Product from "constants/ProductConstants";
import fetchProductLevelRidersBenefit from "./fetchProductLevelRidersBenefit";
import ProductNames from "constants/ProductNames";

const fetchProductLevelBenefits = (productData) => {
  let biData = {};

  if (Array.isArray(productData.data.BI)) {
    biData = productData.data.BI.find(
      (item) => item.risk === productData.selectedTab
    );
  } else {
    biData = productData.data;
  }

  if (biData?.bi_request?.PR_ID === ProductNames.flexiSavingsPlan) {
    if (
      biData?.product_name === Product.FLEXI_SAVINGS_PLAN_FLEXI_INCOME ||
      biData?.product_name === Product.FLEXI_SAVINGS_PLAN_FLEXI_INCOME_PRO
    )
      return fetchProductLevelRidersBenefit(
        fspFlexiIncomeAndProBenefits,
        biData
      );

    if (biData?.product_name === Product.FLEXI_SAVINGS_PLAN_LARGE_SUM_OPTION) {
      return fetchProductLevelRidersBenefit(fspLargeSumBenefits, biData);
    }

    return fetchProductLevelRidersBenefit([], biData);
  }
  switch (biData?.product_name) {
    case Product.CASH_FLOW_PROTECTION_PLUS:
      return fetchProductLevelRidersBenefit(cashFlowProtectionBenefits, biData);

    case Product.GCAP:
      return fetchProductLevelRidersBenefit(gcapBenefits, biData);

    case Product.SINGLE_PAY_ENDOWMENT_ASSUARANCE_PLAN:
      return fetchProductLevelRidersBenefit(singlePayEndowmentBenefits, biData);

    case Product.FOREVER_PENSION:
    case Product.FOREVER_PENSION_DEFERRED_ANNUITY:
    case Product.FOREVER_PENSION_IMMEDIATE_ANNUITY:
    case Product.POS_FOREVER_PENSION:
      return foreverPensionBenefits;

    case Product.POS_SARAL_NIVESH:
      return posSaralNiveshBenefits;

    case Product.CRITICARE_PLUS:
      return criticareBenefits;

    case Product.WEALTH_ULTIMA:
    case Product.SYSTEMATIC_WITHDRAWAL_PLAN_WEALTH_ULTIMA:
    case Product.LITTLE_CHAMP_WEALTH_ULTIMA:
      return wealthUltimaBenefits;

    case Product.DHAN_LABH:
      return fetchProductLevelRidersBenefit([], biData);

    case Product.WEALTH_PREMIER:
      return wealthPremierBenefits;

    case Product.ACTIVE_INCOME_PLAN:
    case Product.ACTIVE_INCOME_PLAN_WITH_FIB:
      return fetchProductLevelRidersBenefit(aipBenefits, biData);

    case Product.POS_FOREVER_PENSION:
      return posForeverPensionBenefits;

    case Product.PREMIER_GUARANTEED_INCOME_LUMPSUM:
    case Product.PREMIER_GUARANTEED_SHORT_TERM_INCOME:
    case Product.PREMIER_GUARANTEED_LONG_TERM_INCOME:
    case Product.PREMIER_GUARANTEED_RETIREMENT_INCOME:
    case Product.GUARANTEED_INCOME_STAR:
    case Product.GUARANTEED_FLEX_STAR:
    case Product.ASSURED_INCOME_STAR:
    case Product.SMART_LIFESTYLE:
      return fetchProductLevelRidersBenefit([], biData);

    case Product.GUARANTEED_SAVINGS_STAR_LUMPSUM:
    case Product.GUARANTEED_SAVINGS_STAR_INCOME:
      return fetchProductLevelRidersBenefit(gssLumpsumIncomeBenefits, biData);

    case Product.PREMIER_GUARANTEED_STAR:
      return fetchProductLevelRidersBenefit(pgsBenefits, biData);

    case Product.PREMIER_GUARANTEED_STAR_PRO:
      return fetchProductLevelRidersBenefit(pgsBenefits, biData);

    case Product.INCOME_BUILDER:
    case Product.SECURED_INCOME_OPTION_INCOME_BUILDER:
      return fetchProductLevelRidersBenefit(incomeBuilderBenefits, biData);

    case Product.ZINDAGI_PROTECT:
      if (Number(biData?.bi_request?.PlanOption) === 130) {
        return fetchProductLevelRidersBenefit(
          zindagiProtectLCOBenefits,
          biData
        );
      } else {
        return fetchProductLevelRidersBenefit([], biData);
      }

    case Product.POS_GUARANTEED_SAVINGS_STAR:
      return posGSSBenefits;

    case Product.BHARAT_SAVINGS_STAR_INCOME:
    case Product.BHARAT_SAVINGS_STAR_LUMPSUM:
    case Product.POS_BHARAT_SAVINGS_STAR_INCOME:
    case Product.POS_BHARAT_SAVINGS_STAR_LUMPSUM:
      return fetchProductLevelRidersBenefit(bssBenefits, biData)

    case Product.ACTIVE_PENSION_PLUS:
      return activePensionPlusBenefits;

    default:
      return [];
  }
};

export default fetchProductLevelBenefits;
